import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'counter',
  standalone: true
})
export class CounterPipe implements PipeTransform {

  transform(rawSeconds: number): string {
    const mintues =  Math.floor(rawSeconds / 60);
    let seconds: number | string = rawSeconds % 60;
    if(seconds < 10) {
      seconds = "0" + seconds;
    }
    return `${seconds} : ${mintues}`;
  }

}
